export default class CoordinateSequenceFilter {
  filter(seq, i) {}
  isGeometryChanged() {}
  isDone() {}
}
export default class CoordinateSequenceFilter {
  filter(seq, i) {}
  isGeometryChanged() {}
  isDone() {}
}
